import React, { useReducer, useEffect, useContext } from "react";
import api from "../services/api";
import { AccountContext } from "context/account";
import { materialLibraryDefaultTableHeader } from "utils/data";

export const defaultUserSettingContext = {
  setting: {
    materialLibrary: {
      fields: materialLibraryDefaultTableHeader,
    },
  },
  metadata: {},
};

export const UserSettingContext = React.createContext(defaultUserSettingContext);

const reducer = (state, action) => {
  switch (action.type) {
    case "updateUserSetting":
      return {
        ...state,
        setting: {
          ...state.setting,
          ...action.payload?.setting,
        },
        metadata: {
          ...state.metadata,
          ...action.payload?.metadata,
        },
      };
    default:
      return state;
  }
};

export const UserSettingProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, defaultUserSettingContext);
  const account = useContext(AccountContext);

  useEffect(() => {
    if (account.id) {
      const asyncCall = async () => {
        try {
          await retriveUserSetting();
        } catch (err) {
          console.log(err);
        }
      };
      asyncCall();
    }
  }, [account.id]);

  const retriveUserSetting = () => {
    return api.userSetting.retrieve().then(({ data }) => {
      dispatch({ type: "updateUserSetting", payload: data.setting });
      return data;
    });
  };

  const updateUserSetting = (update) => {
    return api.userSetting.update(update).then(({ data }) => {
      const updated = data.updated;
      if (!updated["metadata"]) {
        updated["metadata"] = {};
      }
      dispatch({ type: "updateUserSetting", payload: updated });
      return data;
    });
  };

  return (
    <UserSettingContext.Provider
      value={{
        ...state,
        retriveUserSetting,
        updateUserSetting,
      }}
    >
      {children}
    </UserSettingContext.Provider>
  );
};
